<template>
  <div
    v-if="count !== undefined"
    class="d-flex align-items-center ms-1 me-3"
  >
    <div class="">
      {{ title }}
    </div>
    <input
      v-model="count"
      class="form-control mx-3 my-2"
      type="number"
      min="1"
      @change="changePropertyValue(ruleProperty)"
    >
    <div class="">
      <RulePropertyRemove
        class="focus-style"
        @click.native="removeRuleProperty(ruleProperty)"
      />
    </div>
  </div>
  <div
    v-else
    class="d-flex my-3 me-3"
  >
    <div class="">
      <RuleSmallButton
        :title="trans(`subscription.validation_rules.rule_property_add`, { name: title })"
        class="focus-style btn-success"
        @click.native="addRuleProperty(ruleProperty)"
      />
    </div>
  </div>
</template>

<script>
import ruleMixin from '@/employees/components/Rule/utilities/mixins/ruleMixin'
export default {
  name: 'RuleMinMaxCountCondition',
  mixins: [ruleMixin],
  props: {
    ruleReference: {
      required: true,
      type: String,
    },
    title: {
      required: true,
      type: String,
    },
    ruleProperty: {
      required: true,
      type: String,
    },
    currentCount: {
      required: false,
      type: Number,
      default: undefined,
    },
  },
  data () {
    return {
      count: undefined,
    }
  },
  mounted () {
    if (this.currentCount !== undefined) {
      this.count = this.currentCount
    }
  },
  methods: {
    removeRuleProperty (rulePropertyEnum) {
      this.rulePropertyValueDelete(this.ruleReference, rulePropertyEnum)
    },
    addRuleProperty (rulePropertyEnum) {
      this.rulePropertyValueAdd(this.ruleReference, rulePropertyEnum, Number(1))
    },
    changePropertyValue (rulePropertyEnum) {
      this.rulePropertyValueChange(this.ruleReference, rulePropertyEnum, Number(this.count))
    },
  },
}
</script>

<style lang="scss" scoped>
.focus-style{
  &:focus {
    border-color: #1b89ff;
    border-width: 1px;
    border-style: solid;
    box-shadow: 0 0 5px rgba(27, 137, 255, .5) !important;
  }
}
</style>
